import React, { useEffect, useState } from 'react';

interface FilePreviewProps {
  file: File | null;
  className?: string;
}

const FilePreview: React.FC<FilePreviewProps> = ({ file, className = '' }) => {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!file) {
      setObjectUrl(null);
      return;
    }

    const url = URL.createObjectURL(file);

    setObjectUrl(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [file]);

  const isPdf = file?.type === 'application/pdf';

  return (
    <div className={`max-h-[20rem] border-2 border-dashed border-gray-300 rounded-lg overflow-y-auto bg-gray-50 w-full ${className}`}>
      {objectUrl && (
        isPdf ? (
          <object
            data={objectUrl}
            type="application/pdf"
            className="w-full aspect-612/792"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <img
              src={objectUrl}
              alt="File preview"
              className="w-full aspect-612/792 object-contain"
            />
          </div>
        )
      )}
    </div>
  );
};

export default FilePreview;